import { useEffect } from 'react';
import { CompleteBookingFragment, useBookingUpdateSubscription } from 'drycut-graphql';

type Props = {
  uid: string;
  callback?: (booking: CompleteBookingFragment) => void;
};

export function useBookingPubSub({ uid, callback }: Props) {
  const { data } = useBookingUpdateSubscription({ variables: { uid } });
  const broadcast: CompleteBookingFragment | undefined = data?.bookingUpdate;

  useEffect(() => {
    if (broadcast) {
      callback?.(broadcast);
    }
  }, [broadcast, callback]);
}
